import React, {Component} from 'react';
import {connect} from 'react-redux'
import MainLayout from '../layout/main';
import AdminLayout from '../layout/admin-layout';
import EmptyLayout from '../layout/empty';
import LayoutContainer from '../layout/layout-container'
import {ToastContainer} from 'react-toastify';
import {Switch, withRouter, Route} from 'react-router-dom';
import ContentPage from '../admin/content-page';

import './App.css';
import 'react-toastify/dist/ReactToastify.min.css';

import {check} from '../../utils/tokenUtils'
import {loadBasket} from '../../actions/orders';
import store from '../../store';
import {getMyProfile} from '../../actions/user';
import {adminMainRoutes, mainRoutes, emptyRoutes, bluRoutes, bluPaths} from '../../data/routes';
import NotFound from '../layout/not-found/index';
import ContentLayout from '../layout/content-layout/content-layout';
import BluPage from "../blu/blu-page";
import {getBluPages} from "../../actions/pages";
import {getFeatures} from "../../actions/features";
import Maintenance from '../maintenance/index';

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showMaintenanceMode: false
    };

    if (check()) {
      store.dispatch(getMyProfile('CURRENT_USER_PROFILE'));

    } else {
      store.dispatch({type: 'SET_VIEWCONFIG_LOADED'})
    }
  }

  setPermission = (permissions) => ({
    action: permissions ? permissions.action : true,
    subjectClass: permissions ? permissions.subjectClass : '',
  });

  getParams = () => {
    const params = {};
    window.location.href.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      (_, key, value) => { (params[key] = value); }
    );

    return params;
  }

  handleMaintenanceSkip = () => {
    const params = this.getParams();
    if (
      process.env.REACT_APP_MAINTENANCE_MODE === 'true' &&
      params.secret !== 'true' &&
      sessionStorage.getItem('maintenanceSkip') !== 'true'
    ) {
      this.setState({
        showMaintenanceMode: true
      });
    } else if (
      params.secret === 'true' ||
      sessionStorage.getItem('maintenanceSkip') === 'true'
    ) {
      this.setState({
        showMaintenanceMode: false
      }, () => {
        sessionStorage.setItem('maintenanceSkip', 'true');
      });
    }
  }

  componentDidMount() {
    this.handleMaintenanceSkip();
    this.props.dispatch(getFeatures())
    this.props.dispatch(getBluPages());
  }

  componentDidUpdate = () => {
    const params = this.getParams();

    if (
      (params.secret === 'true' ||
      sessionStorage.getItem('maintenanceSkip') === true) &&
      this.state.showMaintenanceMode === true
    ) {
      this.handleMaintenanceSkip();
    }
  }

  componentWillUnmount = () => {
    if (sessionStorage.getItem('maintenanceSkip') === true) {
      sessionStorage.removeItem('maintenanceSkip');
    }
  }

  render() {
    const {setPermission, props: {bluPages}} = this;
    const features = this.props.features;
    const filteredPrivateMainRoutes = mainRoutes.private.filter(item => {
      return item.path != '/personal-rewards';
    })

    if (check() && !this.props.userProfile.id) {
      return null;
    }

    const dynamicBluRoutes = bluPages.map(page => {
      const pagePathPrefix =  bluPaths.includes(page.slug) ? '/' : '/content-pages/';
      return {
        path: `${pagePathPrefix}${page.slug}`,
        component: BluPage,
        pageSlug: page.slug
      }
    });

    return (
      <LayoutContainer>
        <ToastContainer
          position="top-right"
          type="default"
          autoClose={5000}
          toastClassName="ignite-toast"
          hideProgressBar
          newestOnTop
          closeOnClick
          pauseOnHover
        />
        <Switch>
          {this.state.showMaintenanceMode && <Route path="/"><Maintenance /></Route>}
          {emptyRoutes.public.map((item, key) => <EmptyLayout key={key} {...item} />)}
          {emptyRoutes.private.map((item, key) => <EmptyLayout key={key} private {...item}  />)}
          {filteredPrivateMainRoutes.map((item, key) => (
            <MainLayout
              key={key}
              private
              {...item}
              {...setPermission(item.permissions)}
            />
          ))};
          {adminMainRoutes.map((item, key) => (
            <AdminLayout
              key={key}
              private
              {...item}
              {...setPermission(item.permissions)}
              {...this.props.viewConfig}
            />
          ))};
          {dynamicBluRoutes.map((item, key) => (
            <MainLayout
              key={key}
              pageSlug={item.pageSlug}
              className="blu"
              private
              {...item}
              {...setPermission(item.permissions)}
            />
          ))};

          <ContentLayout
            path="/content-pages/:pageSlug"
            exactMatch
            component={ContentPage}
            {...setPermission()}
          />
          <EmptyLayout component={NotFound}/>
        </Switch>
      </LayoutContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    location: state.location,
    viewConfig: state.viewConfig,
    userProfile: state.viewConfig.profile,
    bluPages: state.pages.bluPages,
    features: state.features
  };
};

export default withRouter(connect(mapStateToProps)(App));



// WEBPACK FOOTER //
// ./src/components/app/index.jsx